import { PER_PAGE_OPTIONS, PageParams, Pagination } from "../../types/admin";

export const DEFAULT_PAGE: Required<PageParams> = {
  page: 1,
  per_page: PER_PAGE_OPTIONS[0],
};

/** Client-side pagination, for lists the API returns in full. */
export const paginate = <T>(
  items: T[],
  { page, per_page }: Required<PageParams>,
): { items: T[]; pagination: Pagination } => {
  const total_pages = Math.max(1, Math.ceil(items.length / per_page));
  const current = Math.min(Math.max(page, 1), total_pages);
  return {
    items: items.slice((current - 1) * per_page, current * per_page),
    pagination: { page: current, per_page, total: items.length, total_pages },
  };
};
